import { render } from "./AnyQuestion.vue?vue&type=template&id=0906d110&scoped=true"
import script from "./AnyQuestion.vue?vue&type=script&lang=js"
export * from "./AnyQuestion.vue?vue&type=script&lang=js"

import "./AnyQuestion.vue?vue&type=style&index=0&id=0906d110&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0906d110"]])

export default __exports__